import { connect } from 'react-redux';
import { ParticipantViewModel } from 'stageclip-common';

import { fetchQaQueueParticipants } from 'api/participants/participants.actions';
import { fetchEvents } from 'api/events/events.actions';
import { baseMapStateToProps } from 'components/componentBase';
import { QaQueueList } from './QaQueueList';
import { createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getAll } from 'store/selectors';
import { resetParticipantsListAction } from 'actions/participantActions';

const mapStateToProps = (state: ClippingPlatformState) => ({
  ...baseMapStateToProps(state),
  participants: getAll(state.entities.participants),
});

const mapDispatchToProps = (dispatch: Function) => ({
  fetchQaQueueParticipants: () => dispatch(fetchQaQueueParticipants()),
  openVideoReviewModal: (participant: ParticipantViewModel) =>
    dispatch(createModalOpenAction(SimpleModalId.ParticipantReview, { participant })),
  resetParticipantsListAction: () => dispatch(resetParticipantsListAction()),
  fetchEvents: () => dispatch(fetchEvents()),
});

export const QaQueueListContainer = connect(mapStateToProps, mapDispatchToProps)(QaQueueList);
